import store from '@/store'

const getDefaultState = () => {
    return {
        url: '',
        authenticated: false,
        impersonating: null,
        bklrProject: [],
        bklrProjectsFull: [],
        bklrAll: false,
        bklrID06All: false,
        bklrLoading: false,
        mobileExistsOnOtherUser: false,
        emailExistsOnOtherUser: false,
        existOnOtherUserEmailVerification: false,
        inputEmail: null,
        inputMobile: null,
    }
}

const state = getDefaultState()

const getters = {
    url(state: any) {
        return state.url
    },

    authenticated(state: any) {
        return state.authenticated
    },

    // IMPERSONATING
    impersonating(state: any) {
        return state.impersonating
    },

    // BKLR
    bklrLoading(state: any) {
        return state.bklrLoading
    },

    bklrProjects(state: any) {
        return state.bklrProject
    },

    bklrProject: (state: any) => (id: string) => {
        return state.bklrProject ? state.bklrProject.find((project) => project == id) : false
    },

    bklrProjectsFull(state: any) {
        return state.bklrProjectsFull
    },

    hasBklrProject: (state: any) => (id: string) => {
        let res = false
        if (id.startsWith('ID06')) {
            res = state.bklrID06All ? true : state.bklrProject.includes(id)
        } else {
            res = state.bklrAll ? true : state.bklrProject.includes(id)
        }
        return res
    },

    bklrAll(state: any) {
        return state.bklrAll
    },

    bklrID06All(state: any) {
        return state.bklrID06All
    },

    emailExistsOnOtherUser(state: any) {
        return state.emailExistsOnOtherUser
    },

    mobileExistsOnOtherUser(state: any) {
        return state.mobileExistsOnOtherUser
    },

    existOnOtherUserEmailVerification(state: any) {
        return state.existOnOtherUserEmailVerification
    },

    inputEmail(state: any) {
        return state.inputEmail
    },

    inputMobile(state: any) {
        return state.inputMobile
    },
}

const mutations = {
    url(state: any, payload: any) {
        state.url = payload
    },

    // SESSION
    authenticated(state: any, payload: any) {
        state.authenticated = payload
        if (!state.authenticated) {
            store.dispatch('clearAll')
        }
    },

    // IMPERSONATING
    impersonating(state: any, payload: any) {
        state.impersonating = payload
    },

    // bklrProjects
    bklrLoading(state: any, payload: any) {
        state.bklrLoading = payload
    },

    bklrProjects(state: any, payload: any) {
        state.bklrProject = Object.keys(payload)
    },

    bklrProjectsFull(state: any, payload: any) {
        state.bklrProjectsFull = payload
    },

    bklrAll(state: any, payload: any) {
        state.bklrAll = payload
    },

    bklrID06All(state: any, payload: any) {
        state.bklrID06All = payload
    },

    mobileExistsOnOtherUser(state: any, payload: any) {
        state.mobileExistsOnOtherUser = payload ? payload.mobileExistsOnOtherUser : false
        state.inputEmail = payload ? payload.email : null
        state.inputMobile = payload ? payload.mobile : null
    },

    emailExistsOnOtherUser(state: any, payload: any) {
        state.emailExistsOnOtherUser = payload ? payload.emailExistsOnOtherUser : false
        state.inputEmail = payload ? payload.email : null
    },

    existOnOtherUserEmailVerification(state: any, payload: boolean) {
        state.existOnOtherUserEmailVerification = payload
    },

    //RESET
    resetAuthentication(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            if (key != 'authenticated') state[key] = initial[key]
        })
    },
}

const authentication = {
    state,
    getters,
    mutations,
}

export default {
    authentication,
}
